import { aiAgents } from './aiAgents.ts';
import { collab } from './collab.ts';
import { common } from './common.ts';
import { contact } from './contact.ts';
import { cta } from './cta.ts';
import { download } from './download.ts';
import { connectors } from './connectors.ts';
import { faq } from './faq.ts';
import { footer } from './footer.ts';
import { hero } from './hero.ts';
import { knowledge } from './knowledge.ts';
import { legalPage, legalSeo, legalUi } from './legal.ts';
import { modules } from './modules.ts';
import { pm } from './pm.ts';
import { pricing } from './pricing.ts';
import { security } from './security.ts';
import { socialProof } from './socialProof.ts';

/**
 * Bản tiếng Việt — BẢN CHUẨN VỀ HÌNH DẠNG (canonical shape).
 *
 * `type Copy = typeof vi`, nên mọi ngôn ngữ khác thiếu hay gõ sai một khoá là LỖI BIÊN DỊCH,
 * không phải chuỗi `undefined` lọt ra trang production.
 *
 * Tách theo section (design doc §12.3: copy đi cùng lô dựng section đó). Lô sau thêm MỘT file
 * và MỘT dòng ở đây, không sửa dòng nào của lô khác — đó là điều kiện để các lô chạy song song
 * mà không giẫm lên nhau.
 */
export const vi = {
  ...common,

  // Spread LỒNG, không phải `...legal` trơn: `seo` và `page` là khoá LỒNG, nên spread nông sẽ
  // THAY THẾ cả `common.seo`/`common.page` (mất `home`) thay vì gộp vào.
  seo: { ...common.seo, ...legalSeo },
  page: { ...common.page, ...legalPage },
  legal: legalUi,

  hero,
  socialProof,
  modules,
  collab,
  pm,
  aiAgents,
  knowledge,
  connectors,
  security,
  pricing,
  faq,
  download,
  cta,
  contact,
  footer,
};
